/**
 * @generated SignedSource<<aad9af226193d8f31a5f1810c436b49a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTileTooltip_nftItem$data = {
  readonly balanceForUser?: {
    readonly balance: number | null;
  } | null;
  readonly contract: {
    readonly addressWithFields: {
      readonly address: string | null;
    } | null;
  } | null;
  readonly isERC1155: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderWithImage_nftItem" | "useBurnNft_nftItem" | "useRefreshMetadata_nftItem" | "useTransferToken_nftItem">;
  readonly " $fragmentType": "NftItemTileTooltip_nftItem";
};
export type NftItemTileTooltip_nftItem$key = {
  readonly " $data"?: NftItemTileTooltip_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileTooltip_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTileTooltip_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftTokenContract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "addressWithFields",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "NftItemBalance",
          "kind": "LinkedField",
          "name": "balanceForUser",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "balance",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isERC1155",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTransferToken_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBurnNft_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRefreshMetadata_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithImage_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "628a341511d6c8e8c2bf8e5c7ec8d8a8";

export default node;
